var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import Checkbox from "syf-component-library/ui/atoms/Checkbox";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import ModalDialog, { DialogTitle, DialogFooter, DialogButton } from '../../AlmeDialog/ModalDialog';
const DialogContent = styled.div `
  padding: 10px;
  margin: 5px;
  position: relative;
  right: 2px;
  color: black;
  outline: none;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  flex-grow: 1;
  height:120px;
  overflow-y: scroll;
`;
const StyleLabel = styled.label `
position: relative;
left: 8px;
top: 10px;
display: flex;
justify-content:space-between;
padding: 10px 0px;
margin: 5px;
`;
const StyleCheckbox = styled(Checkbox) `

 &>div {
    padding: 5px 0px;
    margin: 0px;
    border-bottom: solid 1px #c8c8c8;
    background-color: #ffffff;
}

&>div:first-of-type {
    border-radius: 10px 10px 0 0;

}
&>div:last-child {
    border-radius: 0 0 10px 10px;
}
&>div > label > div> input{
    margin-right : 0px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
}
 `;
const ControlWrapper = styled.div `
  width: 275px;
  padding: 0;
`;
function formSubmitParams(widgetSelection, endType) {
    return ({
        WidgetSelection: widgetSelection,
        endType,
    });
}
const MultiSelectAccount = (_a) => {
    var { responseAction, responseRevision, value, onChange, status, disabled } = _a, props = __rest(_a, ["responseAction", "responseRevision", "value", "onChange", "status", "disabled"]);
    const [selected, setSelected] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [displayModal, setDisplayModal] = useState(true);
    const [options] = useState(() => responseAction.Values.map(val => ({ DisplayLabel: val.DisplayLabel, status: false })));
    const handleModel = () => {
        setDisplayModal(!displayModal);
        const eventName = responseAction === null || responseAction === void 0 ? void 0 : responseAction.ReturnAppEventName;
        const displayData = selected.map((element) => {
            return options.indexOf(element);
        });
        const parameters = formSubmitParams(JSON.stringify(displayData), 'Completed');
        void props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
    };
    const handleCancelModel = () => {
        setDisplayModal(!displayModal);
        const eventName = responseAction === null || responseAction === void 0 ? void 0 : responseAction.ReturnAppEventName;
        const displayData = options.map((element) => {
            return options.indexOf(element);
        });
        const parameters = formSubmitParams(JSON.stringify(displayData), 'Aborted');
        void props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
    };
    const handleEventEnterListener = () => {
        selected.forEach((item, index) => {
            const elementItem = document.getElementById(`user-account-${index}`);
            elementItem === null || elementItem === void 0 ? void 0 : elementItem.addEventListener("keypress", (ev) => {
                if (ev.key === "Enter") {
                    handelChange(item, !item.status);
                }
            });
        });
        const selectAllbox = document.getElementById(`select-all`);
        selectAllbox === null || selectAllbox === void 0 ? void 0 : selectAllbox.addEventListener("keypress", (ev) => {
            if (ev.key === "Enter") {
                handleSelectAll(!selectAll);
            }
        });
    };
    useEffect(() => {
        handleEventEnterListener();
    });
    const handelChange = (item, itemStatus) => {
        item.status = !itemStatus;
        if (item.status) {
            // eslint-disable-next-line
            setSelected([...selected, item]);
        }
        else {
            setSelected(selected.filter((data) => data.DisplayLabel !== item.DisplayLabel));
            setSelectAll(false);
        }
    };
    const handleSelectAll = (statusupdate) => {
        setSelectAll(statusupdate);
        options.forEach((item) => {
            item.status = statusupdate;
        });
        if (statusupdate) {
            setSelected([...options]);
        }
        else {
            setSelected([]);
        }
    };
    return (React.createElement(React.Fragment, null, displayModal ?
        React.createElement(ModalDialog, { id: 'test', style: { backgroundColor: '#e6e6e6', padding: 5 }, header: React.createElement(DialogTitle, { id: 'alme-survey-dialog-title' }, responseAction.TitleText), footer: React.createElement(DialogFooter, null,
                React.createElement(DialogButton, { id: 'alme-survey-dialog-yes-button', "data-testid": 'alme-survey-dialog-yes-button', buttonType: 'primary', onClick: handleModel }, "Submit"),
                React.createElement(DialogButton, { id: 'alme-survey-dialog-no-button', "data-testid": 'alme-survey-dialog-no-button', buttonType: 'ghost', onClick: handleCancelModel }, "Cancel")) },
            React.createElement(StyleLabel, null,
                React.createElement(Checkbox, { id: `select-all`, icon: React.createElement(FontAwesomeIcon, { icon: faCheck, color: "white" }), key: `select-all`, onChange: () => handleSelectAll(!selectAll), "data-testid": "select-all", isChecked: selectAll }, (selectAll === false) ? "Select All" : "Unselect All")),
            React.createElement(DialogContent, { id: "alme-survey-dailog-content", tabIndex: 0 }, options.map((item, index) => (React.createElement(ControlWrapper, { key: `user-account-option-${index}` },
                React.createElement(StyleCheckbox, { icon: React.createElement(FontAwesomeIcon, { icon: faCheck, color: "white" }), id: `user-account-${index}`, "data-testid": `user-account-${index}`, onChange: () => handelChange(item, item.status), isChecked: item.status }, item.DisplayLabel))))))
        : null));
};
export default MultiSelectAccount;
